module.exports = __webpack_public_path__ + "img/youtube-logotype.17ced3fc.png";